import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { AppBar, Breadcrumbs, Grid } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import clsx from 'clsx';
import { muiTheme } from '../styling/Styles';
import ProjectPageBreadcrumb from './ProjectPageBreadcrumb';

const WabliBreadcrumb = (props) => {
  const { name, selectedProject, selectedPage } = props;

  const navigate = useNavigate();
  const changeToHome = () => {
    navigate('/');
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <AppBar position="static" style={{ backgroundColor: '#CFD8E0' }}>
        <div className={clsx('generalMarg')}>
          <Grid container justifyContent="space-between">
            <Breadcrumbs
              separator={name !== '' && <NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <span aria-hidden="true" className={clsx('teamSelector','boldBlue', 'MuiTypography-root')}  onClick={changeToHome}>
                Home
              </span>
              <div className={clsx(selectedProject > -1 ? 'boldBlue' : 'lightBlue')}>{name}</div>
              {selectedProject > -1 ? (
                <ProjectPageBreadcrumb
                  selectedPage={selectedPage}
                  selectedProject={selectedProject}
                />
              ) : null}
            </Breadcrumbs>
          </Grid>
        </div>
      </AppBar>
    </ThemeProvider>
  );
};

export default WabliBreadcrumb;
